/**
 * Created by contrapro on 2018/4/16
 */

import React from 'react';
import { Component } from "react";
import { connect } from 'react-redux';
import './HowtoView.css';
import { VIEW_STATE, getWishPanelTitle, MAX_WISH_NUM } from '../../../util/constConfig';
import { updateViewState, onShareOK, toggleSharePanel } from "../../../actions";
import { updateJSSDK } from "../../../util/wxUtil";
import { getJSSDKSignConfigHost, getStaticHost } from '../../../util/serverUtil';

import btn1 from '../../../assets/imgs/howto_back.png';
import howto from '../../../assets/imgs/howto.png';

class HowtoView extends Component {

    constructor(props) {
        super(props);

        this.onBack = this.onBack.bind(this);

    }

    componentDidMount() {

    }

    onBack() {
        console.log('onBack');
        this.props.updateViewState(VIEW_STATE.HOME);
    }

    render() {
        return (
            <div className="HowtoView">
                    <img className="HowtoView-btn1" alt="" src={btn1} onClick={this.onBack} />
                    <img className="HowtoView-howto" alt="" src={howto} />
            </div>
        );
    }
}


export default connect(state => ({
        viewState: state.viewStateReducer.viewState,
    }),
    dispatch => ({
        updateViewState: (sceneData) => {
            dispatch(updateViewState(sceneData))
        },
        onShareOK: () => {
            // dispatch(authFail())
            dispatch(onShareOK())
        },
        toggleSharePanel: (visible) => {
            dispatch(toggleSharePanel(visible))
        }
    }))(HowtoView)


// WEBPACK FOOTER //
// ./src/react/views/howto/HowtoView.js